<template src="./template.html"></template>

<script>
import Promise from 'bluebird'
import { mapState } from 'vuex'
import _find from 'lodash/find'
import _filter from 'lodash/filter'
import _groupBy from 'lodash/groupBy'
import moment from 'moment'
import Vue from 'vue'

import store from 'src/store'
import chatMessageService from 'api/chatMessage'
import * as mutationTypes from 'store/mutationTypes'
import dateUtils from 'utils/dateUtils'
import pubsubLib from 'lib/pubsub'
import soundsLib from 'lib/sounds'

const CUSTOMER_CHAT_MESSAGE_TYPES = {
  EVENT: 'EVENT',
}

const CUSTOMER_CHAT_MESSAGE_EVENT_TYPES = {
  //thread
  THREAD_CLOSED: 'THREAD_CLOSED',
  THREAD_REOPENED: 'THREAD_REOPENED',
  //bookings
  BOOKING_REFUNDED: 'BOOKING_REFUNDED',
  //reservations
  RESERVATION_REQUEST_CREATED: 'RESERVATION_REQUEST_CREATED',
  RESERVATION_CREATED: 'RESERVATION_CREATED',
  RESERVATION_CANCELLED: 'RESERVATION_CANCELLED',
  //guestlist
  GUEST_LIST_REQUEST_CREATED: 'GUEST_LIST_REQUEST_CREATED',
  GUEST_LIST_CREATED: 'GUEST_LIST_CREATED',
  GUEST_LIST_CANCELLED: 'GUEST_LIST_CANCELLED',
  //tickets
  TICKET_CREATED: 'TICKET_CREATED',
  TICKET_CANCELLED: 'TICKET_CANCELLED',
  //orders
  ORDER_CREATED: 'ORDER_CREATED',
  //timeslots
  TIMESLOT_CREATED: 'TIMESLOT_CREATED',
}

const CUSTOMER_CHAT_MESSAGE_EVENT_TYPES_TO_SHOW_EVENT_TEXT = [
  //reservations
  CUSTOMER_CHAT_MESSAGE_EVENT_TYPES.RESERVATION_CREATED,
  CUSTOMER_CHAT_MESSAGE_EVENT_TYPES.RESERVATION_REQUEST_CREATED,
  CUSTOMER_CHAT_MESSAGE_EVENT_TYPES.RESERVATION_CANCELLED,
  //guestlist
  CUSTOMER_CHAT_MESSAGE_EVENT_TYPES.GUEST_LIST_REQUEST_CREATED,
  CUSTOMER_CHAT_MESSAGE_EVENT_TYPES.GUEST_LIST_CREATED,
  CUSTOMER_CHAT_MESSAGE_EVENT_TYPES.GUEST_LIST_CANCELLED,
  //tickets
  CUSTOMER_CHAT_MESSAGE_EVENT_TYPES.TICKET_CREATED,
  CUSTOMER_CHAT_MESSAGE_EVENT_TYPES.TICKET_CANCELLED,
  //order
  CUSTOMER_CHAT_MESSAGE_EVENT_TYPES.ORDER_CREATED,
  //timeslots
  CUSTOMER_CHAT_MESSAGE_EVENT_TYPES.TIMESLOT_CREATED,
]

export default {
  name: 'customer-chat',
  data() {
    return {
      CUSTOMER_CHAT_MESSAGE_TYPES,
      CUSTOMER_CHAT_MESSAGE_EVENT_TYPES,
      CUSTOMER_CHAT_MESSAGE_EVENT_TYPES_TO_SHOW_EVENT_TEXT,
      loading: false,
      saving: false,
      // pubsubCustomerChatMessageChannelListener: null,
      customerChatThread: null,
      addChatMessageForm: {
        text: null,
      },
      //
      pageSize: 10,
      pageNumber: 1,
    }
  },
  computed: {
    ...mapState({
      venue: (state) => state.venue.current,
      date: (state) => state.date.current,
      user: (state) => state.user.current,
      chatMessages: (state) => state.chat.messages,
      totalChatMessages: (state) => state.chat.totalMessages,
      chatVisible: (state) => state.chatApp.visible,
      totalUnreadChatMessages: (state) => state.chat.totalUnreadMessages,
    }),
    customerInitials() {
      if (!this.user) return ''

      if (this.user.firstName && this.user.lastName) {
        return this.user.firstName.substring(0, 1) + this.user.lastName.substring(0, 1)
      }

      if (this.user.firstName) {
        return this.user.firstName.substring(0, 1)
      }

      if (this.user.lastName) {
        return this.user.lastName.substring(0, 1)
      }

      return ''
    },
    chatMessageGroups() {
      const chatMessages = this.chatMessages.map((m) => {
        m.createdDiary = moment(m.created, dateUtils.isISO8601Format(m.created) ? null : 'x')
          .hour(0)
          .minute(0)
          .second(0)
          .millisecond(0)
          .format('MM/DD/YYYY')

        return m
      })

      const groups = _groupBy(chatMessages, 'createdDiary')

      return Object.keys(groups).map((date) => {
        return {
          date,
          messages: groups[date],
        }
      })
    },
  },
  methods: {
    scrollMessagesIntoView() {
      Vue.nextTick(() => {
        if (!this.$refs.messagesEl) return

        this.$refs.messagesEl.scrollTo({
          top: 1000000,
        })
      })
    },
    onChatMessageReceived(message) {
      const existingMessage = _find(this.chatMessages, {
        id: message.id,
      })

      if (!existingMessage) {
        this._addChatMessage(message)

        soundsLib.playBeep()

        const newTotalUnread = (this.totalUnreadChatMessages || 0) + 1

        if (!this.chatVisible) {
          this.$store.dispatch('setCurrentChatTotalUnreadMessages', newTotalUnread)
        }
      } else {
        console.log('ignore, existing message') //eslint-disable-line
      }

      this.scrollMessagesIntoView()
    },
    _addChatMessage(message) {
      if (!message) throw new Error('message')

      const chatMessages = this.chatMessages || []

      chatMessages.push(message)

      this.$store.dispatch('setCurrentChatMessages', chatMessages)
    },
    // onChatIsTypingReceived(message) {
    //   console.log('TYPING RECEIVED', message);
    // },
    onChatKeyup() {
      // if ((e.keyCode || e.charCode) === 13 && this.addChatMessageForm.text.length > 0) {
      //   pubsubLib.publishToIsTypingChannel(this.addChatMessageForm.text);
      //
      //   this.addChatMessageForm.text = '';
      // }
      // let isTyping = false;
      //
      // const inputHasText = this.addChatMessageForm.text.length > 0;
      //
      // if ((inputHasText && !isTyping) || (!inputHasText && isTyping)) {
      //   isTyping = !isTyping;
      //
      //   pubsubLib.publishToIsTypingChannel(this.user.id, inputHasText ? '1' : '0');
      // }
    },
    resetPaging() {
      this.pageNumber = 1
    },
    createChatMessage() {
      return this.$validator.validateAll().then((success) => {
        if (success) {
          this.saving = true

          const data = {
            venueId: this.venue.id,
            text: this.addChatMessageForm.text,
          }

          return chatMessageService
            .createByVenueIdAndUserId(this.venue.id, this.user.id, data)
            .then((result) => {
              this.saving = false

              const existingMessage = _find(this.chatMessages, {
                id: result.data.id,
              })

              if (!existingMessage) {
                this._addChatMessage(result.data)
              }

              this.addChatMessageForm.text = null

              this.$validator.reset()

              this.scrollMessagesIntoView()
            })
            .catch((error) => {
              this.saving = false

              this.$store.dispatch('addTopBarNotification', {
                text: error.message,
              })

              throw error
            })
        }

        return false
      })
    },
    loadMore() {
      this.pageNumber += 1

      this.getData(true, true).then(() => {
        return null
      })
    },
    getData(page, noScroll = false, disableLoading = false) {
      if (!page) {
        if (!disableLoading) this.loading = true

        this.resetPaging()
      }

      const query = {
        venueId: this.venue.id,
        skip: (this.pageNumber - 1) * this.pageSize,
        limit: this.pageSize,
      }

      return chatMessageService
        .listByUserId(this.user.id, query)
        .then((result) => {
          if (!disableLoading) this.loading = false

          this.$store.dispatch('setCurrentChatTotalMessages', result.count)

          const chatMessages = _filter(result.data, (chatMessage) => {
            const foundMessage = _find(this.chatMessages, {
              id: chatMessage.id,
            })

            return !foundMessage
          })

          this.$store.dispatch('setCurrentChatMessages', chatMessages.concat(this.chatMessages || []))

          if (!noScroll) {
            this.scrollMessagesIntoView()
          }
        })
        .catch((error) => {
          if (!disableLoading) this.loading = false

          this.$store.dispatch('addTopBarNotification', {
            text: error.message,
          })
        })
    },
    getEventTypeFormatted(chatMessage) {
      // const data = chatMessage.data || {};

      switch (chatMessage.eventType) {
        // case CUSTOMER_CHAT_MESSAGE_EVENT_TYPES.BOOKING_REFUNDED:
        //   if (data.admissionGroupType === ADMISSION_GROUP_TYPES.TABLE) {
        //     return 'Reservation refunded';
        //   }
        //
        //   return 'Ticket refunded';
        case CUSTOMER_CHAT_MESSAGE_EVENT_TYPES.RESERVATION_REQUEST_CREATED:
          return 'Reservation requested'
        case CUSTOMER_CHAT_MESSAGE_EVENT_TYPES.RESERVATION_CREATED:
          return 'Reservation added'
        case CUSTOMER_CHAT_MESSAGE_EVENT_TYPES.RESERVATION_CANCELLED:
          return 'Reservation cancelled'
        case CUSTOMER_CHAT_MESSAGE_EVENT_TYPES.GUEST_LIST_REQUEST_CREATED:
          return 'Added to the guestlist'
        case CUSTOMER_CHAT_MESSAGE_EVENT_TYPES.GUEST_LIST_CREATED:
          return 'Guestlist added'
        case CUSTOMER_CHAT_MESSAGE_EVENT_TYPES.GUEST_LIST_CANCELLED:
          return 'Guestlist cancelled'
        case CUSTOMER_CHAT_MESSAGE_EVENT_TYPES.TICKET_CREATED:
          return 'Ticket added'
        case CUSTOMER_CHAT_MESSAGE_EVENT_TYPES.TICKET_CANCELLED:
          return 'Ticket cancelled'
        case CUSTOMER_CHAT_MESSAGE_EVENT_TYPES.THREAD_CLOSED:
          return `Chat closed by ${chatMessage.fromOrganizationMemberName}`
        case CUSTOMER_CHAT_MESSAGE_EVENT_TYPES.THREAD_REOPENED:
          return `Chat reopened by ${chatMessage.fromOrganizationMemberName}`
        default:
          return ''
      }
    },
    onMutation(mutation) {
      if (mutation.type === mutationTypes.SHOW_CHAT_APP) {
        Vue.nextTick(() => {
          this.focusInputEl()
        })

        if (this.chatVisible) {
          this.$store.dispatch('setCurrentChatTotalUnreadMessages', 0) //always reset the count when we open the chat widget
        }

        this.getData(true, false, true)
      }
    },
    focusInputEl() {
      if (this.$refs.chatInputEl) {
        this.$refs.chatInputEl.focus()
      }
    },
  },
  created() {
    this.storeUnsubscribe = store.subscribe(this.onMutation)
  },
  mounted() {
    this.pubsubCustomerChatMessageChannelListener = pubsubLib.subscribeToChatMessageChannel(this.user.id, this.onChatMessageReceived)
    // this.pubsubCustomerChatIsTypingChannelListener = pubsubLib.subscribeToIsTypingChannel(this.user.id, this.onChatIsTypingReceived);

    Promise.all([this.getData()]).then(() => {
      this.focusInputEl()

      return null
    })
  },
  destroyed() {
    if (this.storeUnsubscribe) this.storeUnsubscribe()

    this.pubsubCustomerChatMessageChannelListener.remove()
    // this.pubsubCustomerChatIsTypingChannelListener.remove();
  },
}
</script>



// WEBPACK FOOTER //
// src/components/CustomerChat/index.vue